import TextField from "@material-ui/core/TextField";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionChangeField } from "../../store/invoice/create/actions";
import { FieldNumberFC } from "./types";

const FieldNumber: FieldNumberFC = ({saving}) => {
  const dispatch = useDispatch();
  const { value, error } = useSelector(
    ({
      invoice: {
        create: { invoice, errors },
      },
    }) => ({ value: invoice?.number ?? "", error: errors?.number ?? false })
  );
  return (
    <TextField
      error={error}
      disabled={saving}
      value={value}
      onChange={({ target: { value } }) => {
        dispatch(actionChangeField({ field: "number", value }));
      }}
      placeholder={"Введите номер накладной"}
      fullWidth
    />
  );
};

export default FieldNumber;
